import { history } from '@store/store'

export const getSearchParam = (name: string): string | null => {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get(name)
}

export const setSearchParam = (name: string, value: string | boolean) => {
  const url = new URL(window.location.href)

  if (url.searchParams.get(name) === String(value)) {
    return
  }

  url.searchParams.set(name, String(value))
  replaceUrlWithoutRefresh(url)
}

export const deleteSearchParam = (name: string) => {
  const url = new URL(window.location.href)

  if (!url.searchParams.has(name)) {
    return
  }

  url.searchParams.delete(name)
  replaceUrlWithoutRefresh(url)
}

export const replaceUrlWithoutRefresh = (url: URL | string) => {
  const path =
    typeof url === 'string' ? url : `${url.pathname}${url.search}${url.hash}`

  history.replace(path)
}
